var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { language as getLanguage } from "../../shared/languagesList";
import t from "../I18N/t";

export class DocumentLanguage extends Component {
  render() {
    const { doc } = this.props;

    if (!doc.get('file')) {
      return null;
    }

    if (doc.get('file')) {
      const fileLanguage = doc.getIn(['file', 'language']);
      if (fileLanguage && fileLanguage !== 'other') {
        if (this.props.locale === getLanguage(fileLanguage, 'ISO639_1')) {
          return null;
        }

        return /*#__PURE__*/(
          _jsx("span", { className: "item-type__documentLanguage" }, void 0, /*#__PURE__*/
          _jsx("span", {}, void 0, getLanguage(fileLanguage, 'ISO639_1') || fileLanguage)));


      }

      return /*#__PURE__*/(
        _jsx("span", { className: "item-type__documentLanguage" }, void 0, /*#__PURE__*/
        _jsx("span", {}, void 0, t('System', 'Other'))));


    }
  }
}






export const mapStateToProps = ({ locale }) => ({ locale });

export default connect(mapStateToProps)(DocumentLanguage);